declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

export function trackLeadCreated() {
  try {
    window.oaiq?.("measure", "lead_created", { type: "customer_action" });
  } catch (err) {
    console.warn("oaiq lead_created failed:", err);
  }
}
